var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-layout',{attrs:{"view":"hHh LpR fFf"}},[_c('q-header',{staticClass:"bg-accent text-white",attrs:{"elevated":""}},[_c('TopBar')],1),_c('q-page-container',[_c('div',{staticClass:"full-width full-height",attrs:{"id":"wrapper"}},[_c('RegistroExterno')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }